// Italian category labels.
export const HELP_CATEGORIES = [
  { id: 'getting-started', label: 'Per iniziare', icon: '🚀' },
  { id: 'data', label: 'Preparazione e caricamento dati', icon: '📁' },
  { id: 'analysis', label: 'Esecuzione di un\'analisi', icon: '▶️' },
  { id: 'results', label: 'Comprendere i risultati', icon: '📊' },
  { id: 'troubleshooting', label: 'Risoluzione problemi', icon: '🛠️' },
]
